<app-breadcrumb [title]="'Pasos del Plan'" [items]="['Pesv']" [active_item]="'Pasos del Plan'"></app-breadcrumb>

<div class="container-fluid">
    <div class="card">
        <div class="card-header d-flex align-items-center bg-primary text-white">
            <i class="icofont icofont-tasks me-2"></i>
            <h5 class="mb-0"><strong>PASOS DEL PLAN ANUAL DE TRABAJO</strong></h5>
        </div>

        <div class="card-body">

            <div class="table-responsive mt-2">
                <ng-container *ngIf="pasosAgrupados?.length > 0; else sinActividades">
                    <table id="tblActividadesPasosPlan" class="table table-bordered align-middle tabla-pasos-plan">
                        <thead class="bg-primary text-white">
                            <tr>
                                <th class="text-center" style="width: 16%;">PASO</th>
                                <th class="text-center">ACTIVIDAD</th>
                                <th class="text-center" style="width: 13%;">RESPONSABLE</th>
                                <th class="text-center" style="width: 10%;">FECHA PROGRAMADA</th>
                                <th class="text-center" style="width: 7%;">ESTADO</th>
                                <th class="text-center" style="width: 10%;">ACCIONES</th>
                            </tr>
                        </thead>

                        <!-- 🔹 Un <tbody> por paso real (ya no por vínculo) -->
                        <tbody
                            *ngFor="let pasoAgrupado of pasosAgrupados | paginate: { itemsPerPage: pageSizeActividades, currentPage: pageActividades, id: 'actividadesPagination' }"
                            class="grupo-paso">

                            <tr *ngFor="let fila of pasoAgrupado.filas; let i = index">
                                <td *ngIf="i === 0" [attr.rowspan]="pasoAgrupado.filas.length"
                                    class="text-center align-middle text-black bg-light">
                                    {{ pasoAgrupado.nombrePaso }}
                                </td>

                                <td>{{ fila.act?.actividad || '-' }}</td>
                                <td class="text-center">{{ fila.act?.ResponsablePlanData?.nombreCompleto || '-' }}</td>
                                <td class="text-center">{{ fila.act?.fecha_programada | date:'dd/MM/yyyy' }}</td>
                                <td class="text-center">
                                    <span class="badge rounded-pill"
                                        [ngClass]="fila.act?.estado === 1 ? 'bg-success' : 'bg-secondary'">
                                        {{ fila.act?.estado === 1 ? 'ACTIVO' : 'INACTIVO' }}
                                    </span>
                                </td>

                                <td class="text-center">
                                    <div class="d-flex justify-content-center gap-2">
                                        <button class="btn btn-sm btn-outline-info rounded-pill btn-rounded"
    ngbTooltip="Seguimiento de la actividad" [disabled]="!fila.act"
    (click)="abrirModalSeguimientos(modalSeguimiento, fila.act)">
    <i class="icofont icofont-clock-time" style="font-size: .85rem;"></i>
    <span *ngIf="fila.act?.SeguimientoActividadData?.length"
        class="badge bg-info ms-1">
        {{ fila.act.SeguimientoActividadData?.length }}
    </span>
</button>
                                        <button *ngIf="fila.act?.estado === 1"
                                            class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
                                            ngbTooltip="Editar actividad"
                                            (click)="abrirModalActividad(modalActividad, fila)">
                                            <i class="icofont icofont-pencil" style="font-size: .85rem;"></i>
                                        </button>
                                        <button class="btn btn-sm btn-outline-secondary rounded-pill btn-rounded"
                                            *ngIf="fila.act?.estado === 1" ngbTooltip="Inactivar actividad"
                                            (click)="cambiarEstadoGrupo(fila.grupo, false)">
                                            <i class="icofont icofont-close" style="font-size: .85rem;"></i>
                                        </button>
                                        <button class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
                                            *ngIf="fila.act?.estado !== 1" ngbTooltip="Activar actividad"
                                            (click)="cambiarEstadoGrupo(fila.grupo, true)">
                                            <i class="icofont icofont-check" style="font-size: .85rem;"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </ng-container>

                <ng-template #sinActividades>
                    <div class="text-center py-4 text-primary">No hay actividades registradas.</div>
                </ng-template>
            </div>

            <div class="d-flex justify-content-between align-items-center mt-3">
                <div class="d-flex align-items-center">
                    <label for="pageSizeActividades" class="me-2">Mostrar:</label>
                    <select id="pageSizeActividades" class="form-select w-auto" [(ngModel)]="pageSizeActividades"
                        [ngModelOptions]="{standalone: true}" (change)="pageActividades = 1">
                        <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
                    </select>
                    <span class="ms-2">registros por página</span>
                </div>

                <div class="text-center flex-grow-1">
                    Total Registros:
                    <a class="badge badge-primary"><b>{{ pasosAgrupados?.length || 0 }}</b></a>
                </div>

                <div class="text-end">
                    <pagination-controls id="actividadesPagination" (pageChange)="pageActividades = $event"
                        [maxSize]="5" [directionLinks]="true" [autoHide]="true" previousLabel="Anterior"
                        nextLabel="Siguiente"></pagination-controls>
                </div>
            </div>

            <div class="mt-4">
                <div class="btn-showcase text-center">
                    <button class="btn btn-outline-success-2x" type="button" ngbTooltip="Exportar a Excel"
                        (click)="exportarExcel('tblActividadesPasosPlan','Listado_Actividades')">
                        <i class="icofont icofont-file-excel"></i> EXCEL
                    </button>
                    <button class="btn btn-outline-danger-2x" type="button" ngbTooltip="Exportar a PDF"
                        (click)="exportToPDF('tblActividadesPasosPlan','Listado_Actividades','Listado de Actividades')">
                        <i class="icofont icofont-file-pdf"></i> PDF
                    </button>
                    <button type="button" class="btn btn-primary btn-sm" (click)="abrirModalActividad(modalActividad)">
                        <i class="icofont icofont-plus me-1"></i>AGREGAR ACTIVIDAD
                    </button>
                </div>
            </div>

        </div>
    </div>
</div>


<!-- ===================== MODAL: ACTIVIDAD ===================== -->
<ng-template #modalActividad let-modal>
    <div class="modal-header bg-primary text-white">
        <h5 class="modal-title">
            <i class="icofont icofont-edit me-2"></i>
            {{ actividadEditando ? 'Editar actividad' : 'Agregar actividad' }}
        </h5>
        <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        <form [formGroup]="actividadesForm" novalidate>

            <div class="mb-3">
                <label class="form-label text-black">Paso: <span class="text-danger">*</span></label>
                <ng-select [items]="listaPasos" bindValue="id" placeholder="Seleccione el paso"
                    formControlName="id_paso" [clearable]="false"
                    [class.is-invalid]="actividadesForm.get('id_paso')?.invalid && actividadesForm.get('id_paso')?.touched">

                    <ng-template ng-label-tmp let-item="item">
                        {{ item.id }} - {{ item.paso }}
                    </ng-template>

                    <ng-template ng-option-tmp let-item="item">
                        {{ item.id }} - {{ item.paso }}
                    </ng-template>

                </ng-select>
                <div class="invalid-feedback d-block"
                    *ngIf="actividadesForm.get('id_paso')?.invalid && actividadesForm.get('id_paso')?.touched">
                    Debe seleccionar el paso al que pertenecen estas actividades.
                </div>
            </div>

            <hr>

            <div formArrayName="actividades">
                <div class="card border mb-3" *ngFor="let item of actividadesArray.controls; let i = index"
                    [formGroupName]="i">
                    <div class="card-body">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <span class="badge bg-secondary">Actividad {{ i + 1 }}</span>
                            <button type="button" class="btn btn-outline-danger btn-sm"
                                (click)="eliminarFilaActividad(i)" ngbTooltip="Quitar actividad">
                                <i class="icofont icofont-ui-delete"></i>
                            </button>
                        </div>

                        <div class="row g-2">
                            <div class="col-md-6">
                                <label class="form-label small text-black">Responsable <span
                                        class="text-danger">*</span></label>
                                <ng-select [items]="Responsable" bindLabel="nombreConCargo" bindValue="cedula"
                                    placeholder="Seleccione el cargo" formControlName="responsable" [clearable]="false">
                                </ng-select>
                            </div>

                            <div class="col-md-3">
                                <label class="form-label small text-black">Fecha programada <span
                                        class="text-danger">*</span></label>
                                <input type="date" class="form-control form-control-sm"
                                    formControlName="fecha_programada"
                                    [class.is-invalid]="item.get('fecha_programada')?.invalid && item.get('fecha_programada')?.touched">
                            </div>

                            <div class="col-12">
                                <label class="form-label small text-black">Actividad <span
                                        class="text-danger">*</span></label>
                                <textarea class="form-control form-control-sm" rows="2" maxlength="2000"
                                    formControlName="actividad"
                                    placeholder="Ej: Capacitación en normas de tránsito vigentes."
                                    [class.is-invalid]="item.get('actividad')?.invalid && item.get('actividad')?.touched"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <button type="button" class="btn btn-outline-primary btn-sm" (click)="agregarFilaActividad()">
                <i class="icofont icofont-plus me-1"></i>Agregar otra actividad
            </button>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()"
            [disabled]="guardandoActividades">Cancelar</button>

        <button type="button" class="btn btn-primary" (click)="guardarTodasActividades(modal)"
            [disabled]="guardandoActividades">
            <span *ngIf="!guardandoActividades">
                <i class="icofont icofont-save me-1"></i>{{ actividadEditando ? 'Guardar cambios' : 'Guardar
                actividades' }}
            </span>
            <span *ngIf="guardandoActividades">
                <span class="spinner-border spinner-border-sm me-1" role="status"></span>Guardando...
            </span>
        </button>
    </div>
</ng-template>


<!-- ===================== MODAL: SEGUIMIENTO (por actividad) ===================== -->
<ng-template #modalSeguimiento let-modal>
    <div class="modal-header bg-primary text-white">
        <h5 class="modal-title"><i class="icofont icofont-clock-time me-2"></i>Seguimientos de la actividad</h5>
        <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        <p class="text-black" *ngIf="actividadSeguimientoActual">
            <strong>Actividad:</strong> {{ actividadSeguimientoActual.actividad }}
        </p>

        <div class="text-end mb-2">
            <button type="button" class="btn btn-primary btn-sm" (click)="abrirModalSeguimientoForm(modalSeguimientoForm)">
                <i class="icofont icofont-plus me-1"></i>Agregar seguimiento
            </button>
        </div>

        <div *ngIf="!cargandoSeguimientos; else cargandoSeguimientosTpl" class="table-responsive">
            <ng-container *ngIf="listaSeguimientos?.length > 0; else sinSeguimientos">
                <table class="table table-bordered table-hover align-middle">
                    <thead class="bg-primary text-white">
                        <tr>
                            <th class="text-center">OBSERVACIÓN</th>
                            <th class="text-center">FECHA</th>
                            <th class="text-center">ESTADO</th>
                            <th class="text-center">ACCIONES</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let seguimiento of listaSeguimientos; trackBy: trackBySeguimientoId">
                            <td>{{ seguimiento.observacion }}</td>
                            <td class="text-center">{{ seguimiento.fechaCreacion | date:'dd/MM/yyyy HH:mm' }}</td>
                            <td class="text-center">
                                <span class="badge rounded-pill"
                                    [ngClass]="seguimiento.estado === 1 ? 'bg-success' : 'bg-secondary'">
                                    {{ seguimiento.estado === 1 ? 'ACTIVO' : 'INACTIVO' }}
                                </span>
                            </td>
                            <td class="text-center">
                                <div class="d-flex justify-content-center gap-2">
                                    <button class="btn btn-sm btn-outline-info rounded-pill btn-rounded" ngbTooltip="Documentos"
                                        (click)="abrirModalDocumentosSeguimiento(modalDocumentosSeguimiento, seguimiento)">
                                        <i class="icofont icofont-file-document" style="font-size: .85rem;"></i>
                                    </button>
                                    <button class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
                                        *ngIf="seguimiento.estado === 1" ngbTooltip="Editar"
                                        (click)="abrirModalSeguimientoForm(modalSeguimientoForm, seguimiento)">
                                        <i class="icofont icofont-pencil" style="font-size: .85rem;"></i>
                                    </button>
                                    <button class="btn btn-sm btn-outline-secondary rounded-pill btn-rounded"
                                        *ngIf="seguimiento.estado === 1" ngbTooltip="Inactivar"
                                        (click)="cambiarEstadoSeguimiento(seguimiento)">
                                        <i class="icofont icofont-close" style="font-size: .85rem;"></i>
                                    </button>
                                    <button class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
                                        *ngIf="seguimiento.estado !== 1" ngbTooltip="Activar"
                                        (click)="cambiarEstadoSeguimiento(seguimiento)">
                                        <i class="icofont icofont-check" style="font-size: .85rem;"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>

            <ng-template #sinSeguimientos>
                <div class="text-center py-4 text-primary fst-italic">No hay seguimientos registrados.</div>
            </ng-template>
        </div>

        <ng-template #cargandoSeguimientosTpl>
            <div class="text-center py-4">
                <span class="spinner-border spinner-border-sm me-1" role="status"></span>Cargando seguimientos...
            </div>
        </ng-template>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cerrar</button>
    </div>
</ng-template>

<ng-template #modalSeguimientoForm let-modal>
    <div class="modal-header bg-primary text-white">
        <h5 class="modal-title">
            <i class="icofont icofont-edit me-2"></i>
            {{ seguimientoEditando ? 'Editar seguimiento' : 'Agregar seguimiento' }}
        </h5>
        <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        <form [formGroup]="seguimientoForm" novalidate>
            <div class="mb-2">
                <label class="form-label text-black">Observación: <span class="text-danger">*</span></label>
                <textarea class="form-control" rows="4" maxlength="3000" formControlName="observacion"
                    [class.is-invalid]="seguimientoForm.get('observacion')?.invalid && seguimientoForm.get('observacion')?.touched">
                </textarea>
                <div class="invalid-feedback"
                    *ngIf="seguimientoForm.get('observacion')?.invalid && seguimientoForm.get('observacion')?.touched">
                    Este campo es obligatorio (máx. 3000 caracteres).
                </div>
                <small class="text-secondary">Máximo 3000 caracteres.</small>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()"
            [disabled]="guardandoSeguimiento">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="guardarSeguimiento(modal)"
            [disabled]="guardandoSeguimiento">
            <span *ngIf="!guardandoSeguimiento">
                <i class="icofont icofont-save me-1"></i>{{ seguimientoEditando ? 'Guardar cambios' : 'Guardar seguimiento' }}
            </span>
            <span *ngIf="guardandoSeguimiento">
                <span class="spinner-border spinner-border-sm me-1" role="status"></span>Guardando...
            </span>
        </button>
    </div>
</ng-template>

<!-- ===================== MODAL: DOCUMENTOS DEL SEGUIMIENTO ===================== -->
<ng-template #modalDocumentosSeguimiento let-modal>
    <div class="modal-header bg-primary text-white">
        <h5 class="modal-title">
            <button *ngIf="mostrandoPreviewDocumento" type="button" class="btn btn-sm btn-light me-2"
                (click)="cerrarPreviewDocumento()" ngbTooltip="Volver">
                <i class="icofont icofont-arrow-left"></i>
            </button>
            {{ mostrandoPreviewDocumento ? (documentoSeleccionado?.name || 'Documento') : 'Documentos del seguimiento' }}
        </h5>
        <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>

    <div class="modal-body">

        <ng-container *ngIf="!mostrandoPreviewDocumento">

            <div class="alert alert-secondary d-flex align-items-center mb-4"
                *ngIf="seguimientoSeleccionadoDocs?.estado === 0">
                <i class="icofont icofont-lock fs-5 me-2"></i>
                Este seguimiento está <strong class="mx-1">inactivo</strong>, por lo tanto no se pueden cargar ni modificar
                documentos.
            </div>

            <div class="mb-4" *ngIf="seguimientoSeleccionadoDocs?.estado !== 0">
                <input type="file" class="d-none" id="inputDocumentosSeguimiento" multiple (change)="onFileChangeDocumento($event)">
                <label for="inputDocumentosSeguimiento"
                    class="dropzone-label w-100 d-flex flex-column align-items-center justify-content-center py-4 border border-primary rounded cursor-pointer">
                    <i class="icofont icofont-upload fs-1 text-primary mb-2"></i>
                    <p class="mb-2 fw-semibold text-primary text-center">Haz click o arrastra archivos para cargar</p>
                    <span class="btn btn-primary btn-sm rounded-pill px-3">Seleccionar archivos</span>
                </label>
            </div>

            <div *ngIf="nuevosArchivosDocs.length > 0 && seguimientoSeleccionadoDocs?.estado !== 0" class="mb-4">
                <h6 class="fw-bold">Archivos seleccionados</h6>
                <div class="row g-2">
                    <div class="col-6 col-md-3" *ngFor="let item of nuevosArchivosDocs; let i = index">
                        <div class="card p-2 text-center h-100">
                            <img *ngIf="item.preview" [src]="item.preview" class="mb-1 rounded" style="max-height: 90px; object-fit: cover;">
                            <i *ngIf="!item.preview" class="fa fa-file-pdf-o fs-2 text-danger mb-1"></i>
                            <small class="text-truncate d-block" [title]="item.file.name">{{ item.file.name }}</small>
                            <button class="btn btn-sm btn-outline-danger mt-1" (click)="quitarArchivoNuevo(i)">
                                <i class="bi bi-trash"></i> Quitar
                            </button>
                        </div>
                    </div>
                </div>
                <button class="btn btn-success mt-3" [disabled]="subiendoDocumentos" (click)="subirDocumentosSeguimiento()">
                    <span *ngIf="subiendoDocumentos" class="spinner-border spinner-border-sm me-1"></span>
                    <i class="icofont icofont-cloud-upload me-1"></i> Subir {{ nuevosArchivosDocs.length }} archivo(s)
                </button>
            </div>

            <hr>

            <h6 class="fw-bold">Documentos cargados</h6>
            <div *ngIf="cargandoDocumentos" class="text-center py-3">
                <div class="spinner-border text-primary"></div>
            </div>

            <div *ngIf="!cargandoDocumentos && documentosPlan.length === 0" class="text-primary text-center py-3">
                No hay documentos cargados para este seguimiento.
            </div>

            <div class="row g-2" *ngIf="!cargandoDocumentos && documentosPlan.length > 0">
                <div class="col-12 col-md-4" *ngFor="let doc of documentosPlan">
                    <div class="card p-2 text-center h-100">
                        <img *ngIf="doc.isImage" [src]="doc.url" class="mb-1 rounded cursor-pointer"
                            style="max-height: 90px; object-fit: cover;" (click)="verDocumento(doc)">
                        <i *ngIf="!doc.isImage" class="fa fa-file-pdf-o fs-2 text-danger mb-1 cursor-pointer"
                            (click)="verDocumento(doc)"></i>
                        <small class="text-truncate d-block" [title]="doc.name">{{ doc.name }}</small>
                        <div class="d-flex gap-1 justify-content-center mt-1">
                            <button class="btn btn-sm btn-outline-primary" (click)="verDocumento(doc)">
                                <i class="icofont icofont-eye"></i>
                            </button>
                            <button class="btn btn-sm btn-outline-warning" *ngIf="seguimientoSeleccionadoDocs?.estado !== 0"
                                (click)="reemplazarDocumentoSeguimiento(doc)">
                                <i class="icofont icofont-refresh"></i>
                            </button>
                            <button class="btn btn-sm btn-outline-danger" *ngIf="seguimientoSeleccionadoDocs?.estado !== 0"
                                (click)="eliminarDocumentoSeguimiento(doc)">
                                <i class="icon-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </ng-container>

        <ng-container *ngIf="mostrandoPreviewDocumento">
            <div class="text-center" style="min-height: 50vh;">

                <img *ngIf="documentoSeleccionado?.isImage" [src]="documentoSeleccionado?.url" class="img-fluid rounded"
                    style="max-height: 65vh;">

                <iframe *ngIf="documentoSeleccionado?.isPdf" [src]="documentoSeleccionado?.urlSegura"
                    style="width: 100%; height: 65vh; border: none;">
                </iframe>

                <div *ngIf="!documentoSeleccionado?.isImage && !documentoSeleccionado?.isPdf"
                    class="d-flex flex-column align-items-center justify-content-center py-5">
                    <i class="fa fa-file-o fs-1 text-secondary mb-3"></i>
                    <p class="text-muted">Este tipo de archivo no se puede previsualizar en el navegador.</p>
                </div>

                <a *ngIf="documentoSeleccionado?.url" [href]="documentoSeleccionado?.url" target="_blank"
                    class="btn btn-outline-primary mt-3">
                    <i class="icofont icofont-download"></i> Abrir en pestaña nueva
                </a>
            </div>
        </ng-container>

    </div>

    <div class="modal-footer">
        <button *ngIf="mostrandoPreviewDocumento" type="button" class="btn btn-outline-secondary"
            (click)="cerrarPreviewDocumento()">
            <i class="icofont icofont-arrow-left me-1"></i>Volver al listado
        </button>
        <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Cerrar</button>
    </div>
</ng-template>